<template>
    <section class="customer">
        <van-tabbar v-model="active" @change="changeTabbar" active-color="#098bef" inactive-color="#9BA5B7">
            <van-tabbar-item name="customer">
                <span>线索</span>
                <template #icon="props">
                    <img :src="props.active ? customerActivedIcon : customerUnactivedIcon" />
                </template>
            </van-tabbar-item>

            <van-tabbar-item name="promotion" v-if="token && accountType == 0">
                <span>计划</span>
                <template #icon="props">
                    <img :src="props.active ? promotionActivedIcon : promotionUnactivedIcon" />
                </template>
            </van-tabbar-item>

            <van-tabbar-item name="setting">
                <span>我的</span>
                <template #icon="props">
                    <img :src="props.active ? settingActivedIcon : settingUnactivedIcon" />
                </template>
            </van-tabbar-item>
        </van-tabbar>
        <Login :isLoginModel="isLoginModel" :type="type" :topLeftArrow="topLeftArrow" @closeModel="isLoginModel = false"
            @loginStatus="loginStatus" @loginModelFn="loginModelFn" />
        <van-nav-bar @click-left="onRefresh" title="线索" class="top_bar">
            <template #left>
                <van-icon name="replay" size="20" color="#098bef" />
            </template>
        </van-nav-bar>
        <van-popup
            v-model="showRight"
            position="right"
            :style="{ width: '80%', height: '100%' }"
        >
            <van-form @submit="onSearch">
                    <van-field name="businessStatus" label="业务状态">
                        <template #input>
                            <van-radio-group v-model="params.businessStatus" direction="horizontal">
                                <van-radio v-for="item in businessStatusList" :name="item.value" :key="item.value">{{item.text}}</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>

                    <van-field name="qualificationLabel" label="资质标签">
                        <template #input>
                            <van-radio-group v-model="params.qualificationLabel" direction="horizontal">
                                <van-radio v-for="item in qualificationLabelList" :name="item.value" :key="item.value">{{item.text}}</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>

                    <van-field name="name" label="客户姓名"
                        v-model="params.name"
                        placeholder="请输入客户姓名"
                    />

                    <van-field name="name" label="业务员"
                        v-model="params.currentSalesmanName"
                        placeholder="请输入归属业务员姓名"
                    />

                    <van-field
                        readonly
                        clickable
                        name="calendar"
                        :value="dateRange"
                        label="申请日期"
                        placeholder="点击选择日期"
                        @click="showCalendar = true"
                        />
                    <van-calendar v-model="showCalendar" type="range" :show-confirm="false" :min-date="minDate" :max-date="maxDate" :max-range="30" :allow-same-day="true" @confirm="onCalendarConfirm" />

                    <div style="margin: 16px;">
                        <van-button round block type="primary" native-type="submit">确定</van-button>
                    </div>
                    <div class="clearSearch" @click="onClearSearch"><van-icon name="revoke" />清空条件</div>
                </van-form>
        </van-popup>
        <section v-if="!token" class="nodata_class">
            <div class="no_data">
                <img src="../../assets/img/customer_default.png" />
                <p>请先登录</p>
            </div>
        </section>
        <section v-else-if="isData" class="data_class">
            <van-pull-refresh 
                v-model="refreshing"
                :pulling-text="'上次查询到'+total+'条结果'+'  '+'继续下拉可刷新'"
                :loosing-text="'上次查询到'+total+'条结果'+'  '+'松开可刷新'"
                @refresh="onRefresh"
                :success-text="'已查询到'+total+'条结果'"
                success-duration="1000"
                pull-distance="70"
            >
                <van-list v-model="loading" @load="loadMore" :immediate-check="false" :finished="finished"
                    :finished-text="'已全部加载完成'+total+'条搜索结果'">
                    <van-cell class="group" v-for="(item, id) in list" :key="id" @click="skipCusDetails(item.customerId)">
                        <div class="head">
                            <div class="left">
                                <div class="up">
                                    <h3>{{ item.name }}</h3>
                                    <span v-if="item.qualificationLabel == 1" class="bad">资质较差</span>
                                    <span v-else-if="item.qualificationLabel == 2" class="normal">资质一般</span>
                                    <span v-else-if="item.qualificationLabel == 3" class="good">资质良好</span>
                                    <span v-else>资质未标记</span>
                                </div>
                                <div class="down">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                    <g clip-path="url(#clip0_198_1789)">
                                        <mask id="mask0_198_1789" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="10" height="10">
                                        <path d="M10 0H0V10H10V0Z" fill="white"/>
                                        </mask>
                                        <g mask="url(#mask0_198_1789)">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.33333 4.16671C8.34537 6.85004 4.99999 9.16671 4.99999 9.16671C4.99802 9.16531 4.99531 9.16339 4.99187 9.16097C4.77403 9.00739 1.65474 6.80831 1.66666 4.16462C1.66666 2.32879 3.16207 0.833374 4.99999 0.833374C6.83791 0.833374 8.33333 2.32879 8.33333 4.16671ZM4.99993 5.00004C5.58426 5.00004 6.05795 4.52635 6.05795 3.94202C6.05795 3.35769 5.58426 2.884 4.99993 2.884C4.41561 2.884 3.94191 3.35769 3.94191 3.94202C3.94191 4.52635 4.41561 5.00004 4.99993 5.00004Z" fill="#CED7E2"/>
                                        </g>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_198_1789">
                                        <rect width="10" height="10" fill="white"/>
                                        </clipPath>
                                    </defs>
                                    </svg>
                                    <span>{{item.workProvince+'-'+item.workCity}}</span>
                                </div>
                            </div>
                            <div class="right">
                                <div class="up">
                                    <span>{{ item.businessStatus | f_businessStatus}}</span>   
                                </div>
                                <div class="down">
                                    <span>{{item.matchTime}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="content">
                            <div class="block">
                                <div class="detail">
                                    <p v-if="item.currentSalesmanName">{{ item.currentSalesmanName}}</p>
                                    <p v-else class="todo">待分配</p>
                                </div>
                                <p class="title">业务员</p>
                            </div>
                            <div class="block">
                                <div class="detail">
                                    <p>{{ item.followUpCount }}</p>
                                </div>
                                <p class="title">跟进次数</p>
                            </div>
                            <div class="block">
                                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
                                    <path d="M1 1L5 5.30769L1 9.61538" stroke="#727F92" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </van-cell>
                </van-list>
            </van-pull-refresh>                
        </section>
        <section v-else class="nodata_class">
            <div class="no_data">
                <img src="../../assets/img/customer_default.png" />
                <p>
                    <span>暂无记录</span>
                    <br>
                    <span v-if="accountType == 0">请创建计划开始投放获客</span>
                </p>
            </div>
        </section>
    </section>
</template>
  
<script>
import Login from "components/Login";
import customerServer from "api/customer";
import settingServer from "api/setting";
import { Toast,Calendar } from 'vant';

import promotionActivedIcon from "assets/img/flowsheet_124dp_098BEF_FILL0_wght400_GRAD0_opsz48.png";
import promotionUnactivedIcon from "assets/img/flowsheet_124dp_D9D9D9_FILL0_wght400_GRAD0_opsz48.png";
import customerActivedIcon from "assets/img/contact_phone_124dp_098BEF_FILL0_wght400_GRAD0_opsz48.png";
import customerUnactivedIcon from "assets/img/contact_phone_124dp_D9D9D9_FILL0_wght400_GRAD0_opsz48.png";
import settingActivedIcon from "assets/img/account_circle_124dp_098BEF_FILL0_wght400_GRAD0_opsz48.png";
import settingUnactivedIcon from "assets/img/account_circle_124dp_D9D9D9_FILL0_wght400_GRAD0_opsz48.png";

export default {
    name: "customer",
    components: {
        Login,
    },
    data() {
        return {
            promotionActivedIcon,
            promotionUnactivedIcon,
            customerActivedIcon,
            customerUnactivedIcon,
            settingActivedIcon,
            settingUnactivedIcon,

            token: "",
            active: 'customer',
            isData: 1,
            isLoginModel: false,
            topLeftArrow: true,
            type: "login",

            params: {
                pageNum: 0,
                pageSize: 10,
                businessStatus: null,
                qualificationLabel: null,
                currentSalesmanName: null,
                name: null,
                startTime: null,
                endTime: null,
            },
            list: [],
            loading: false,
            finished: false,

            accountType: '',

            accountInfo: {},
            orgInfo: {},

            positionY: 0,

            showRight: false,

            businessStatusList: [
                {value: 0, text: '待跟进'},
                {value: 1, text: '跟进中'},
                {value: 2, text: '已到店'},
                {value: 3, text: '已签约'},
                {value: 4, text: '进件中'},
                {value: 5, text: '审核失败'},
                {value: 6, text: '审核通过'},
                {value: 7, text: '已发放'},
                {value: 8, text: '已完结'},
                {value: 9, text: '已终止'}
            ],

            qualificationLabelList: [
                {value: 1, text: '资质较差'},
                {value: 2, text: '资质一般'},
                {value: 3, text: '资质良好'},
            ],

            showCalendar: false,
            dateRange: '',

            maxDate: new Date(),
            minDate: this.getDateXDaysAgo(new Date(),360),

            refreshing: false,

            total: 0,
        }
    },
    created() {
        this.token = localStorage.getItem("token");
        this.accountType = localStorage.getItem("accountType");
        this.positionY = localStorage.getItem('customer-position-Y');

        if (this.token) {
            if (this.positionY) {
                this.restoreData()
            } else {
                this.loadMore()
            }
            this.getAccountInfo()
        } else {
            this.isLoginModel = true
        }

    },
    mounted() {
        if (this.$store.state.clientType == 2) {
            document.addEventListener("plusready", function () {
                var webview = plus.webview.currentWebview();
                plus.key.addEventListener("backbutton", function () {
                    webview.canBack(function (e) {
                        if (e.canBack) {
                            webview.back();
                        } else {
                            webview.close();
                        }
                    });
                });
            });
        }

        if(window.plus) {
            this.plusRead()
        }else {
            document.addEventListener('plusread', this.plusRead, false);
        }

        this.$nextTick(() => {
            if( this.token && this.positionY ) {
                this.restoreScrollPosition()
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        console.log("before customer Router Leave")

        if( this.token ) {
            this.positionY = document.documentElement.scrollTop
            console.log(`position Y on leaved ${this.positionY}`)
            localStorage.setItem("customer-position-Y",this.positionY)

            localStorage.setItem("customer-list-data",JSON.stringify(this.list))

            localStorage.setItem("customer-params",JSON.stringify(this.params))

            localStorage.setItem("customer-date-range",this.dateRange)

            localStorage.setItem("customer-finished",this.finished)
        }

        next(() => {
        })
    },    

    methods: {
        plusRead() {
            // plus.navigator.setStatusBarBackground('#055CE8');
            // plus.navigator.setStatusBarStyle('light');
        },


        restoreData() {
            this.params = JSON.parse(localStorage.getItem("customer-params"))
            this.list = JSON.parse(localStorage.getItem("customer-list-data"))
            this.dateRange = localStorage.getItem("customer-date-range")?localStorage.getItem("customer-date-range"):''

            if(this.list.length == 0) {
                this.isData = 0
                this.total = 0
            }

            if(localStorage.getItem("customer-finished")=='true') {
                this.finished = true
                this.total = this.list.length
            } else {
                this.finished = false
            }
        },

        restoreScrollPosition() {
            setTimeout(() => {
                document.documentElement.scrollTop = this.positionY
            }, 100);
            console.log(`scrolled To ${this.positionY}`)
        },
                
        getOrgInfo() {
            settingServer.getOrgInfo().then((res) => {
                this.orgInfo = res.data
            })
        },

        getAccountInfo() {
            settingServer.getAccountInfo().then((res) => {
                this.accountInfo = res.data
            })
        },

        changeTabbar() {
            if (this.active == 'team') {
                this.$router.push({ name: 'team' })
            }

            if (this.active == 'promotion') {
                this.$router.push({ name: 'promotion' })
            }

            if (this.active == 'customer') {
                this.$router.push({ name: 'customer' })
            }

            if (this.active == 'setting') {
                this.$router.push({ name: "setting" });
            }            
        },

        //登录回调
        loginStatus(status) {
            if (status == "ok") {
                this.isLoginModel = false;
                
                this.token = localStorage.getItem("token");
                this.accountType = localStorage.getItem("accountType");

                this.loadMore();
                this.getAccountInfo();
            }
        },

        loginModelFn(type) {
            if (type == "login") {
                this.topLeftArrow = true;
            } else {
                this.topLeftArrow = false;
            }
            this.type = type;
            this.isLoginModel = true;
        },

        loadMore() {
            this.params.pageNum++;
            this.loading = true;

            customerServer.getCustomerPageList(this.params).then((res) => {
                this.loading = false;
                this.refreshing = false;

                if (res.data.total > 0) {
                    this.isData = 1;
                    this.total = res.data.total;
                } else {
                    this.isData = 0;
                    this.list = [];
                    this.total = 0;
                }

                if (res.data.list.length > 0) {
                    this.list = this.list.concat(res.data.list);
                }

                if (res.data.boolLastPage) {
                    this.finished = true;
                }
            });
        },

        filterFn() {
            if (!this.token) return (this.isLoginModel = true)

            if (this.accountInfo.authenticationStatus !=2) return Toast('请先完成账户认证')

            if (this.accountInfo.orgAuthenticationStatus !=2) return Toast('请先完成机构认证')

            if (this.accountInfo.subscriptionStatus !=1) return Toast('请先完成订阅')

            // this.$router.push({ name: "customer-add" })
            this.showRight = true
        },

		skipCusDetails(id) {
			this.$router.push({ name: "customer-details", params: { id: id } })
		},

        onSearch() {
            this.params.pageNum = 0
            this.list = []
            this.finished = false
            this.showRight = false
            this.loadMore()
        },

        onClearSearch() {
            this.params.businessStatus = null
            this.params.qualificationLabel = null
            this.params.currentSalesmanName = null
            this.params.name = null
            this.params.startTime = null
            this.params.endTime = null
            this.dateRange = ''
        },

        onCalendarConfirm(date) {
            this.showCalendar = false
            this.params.startTime = this.formatDate(date[0]) + ' 00:00:00'
            this.params.endTime = this.formatDate(date[1]) +' 23:59:59'
            this.dateRange = this.formatDate(date[0]) + '到' + this.formatDate(date[1])
        },

        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");

            const formattedDate = `${year}-${month}-${day}`;
            return formattedDate
        },

        getDateXDaysAgo(date, days) {
            const millisecondsPerDay = 24 * 60 * 60 * 1000; // 一天的毫秒数

            // 获取给定日期的毫秒数
            const timestampMs = date.getTime();

            // 计算 X 天前的时间戳
            const targetTimestampMs = timestampMs - (days * millisecondsPerDay);

            // 创建 X 天前的 Date 对象
            const targetDate = new Date(targetTimestampMs);

            // 返回 X 天前的日期对象
            return targetDate;   
        },

        onRefresh() {
            if (!this.token) return (this.isLoginModel = true)

            if (this.accountInfo.authenticationStatus !=2) return Toast('请先完成账户认证')

            if (this.accountInfo.orgAuthenticationStatus !=2) return Toast('请先完成机构认证')

            if (this.accountInfo.subscriptionStatus !=1) return Toast('请先完成订阅')

            this.params.pageNum = 0
            this.list = []
            this.finished = false

            this.loadMore()
        },
    },
};
</script>
  
<style lang="scss">
.customer {
    padding-top: 46px;
    padding-bottom: 83px;

    .top_c {
        width: 100%;

        img.bg {
            width: 100%;
        }

        img.btn {
            position: absolute;
            top: 66px;
            right: 0;
            width: 88px;
            z-index: 999;
        }
    }


    .data_class {
        position: relative;
        // margin-top: -80px;
        width: 100%;
        border-radius: 24px;
        background: #fdfdfd;

        .group {
            padding: 14px 28px;
            margin-bottom: 20px;
            width: auto;
            line-height: 1;
            background: inherit;
            font-size: inherit;
            color: inherit;
            background-color: rgba(243, 246, 250, 0.5);
            border-radius: 8px;

            .head {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .left .up {
                    display: flex;
                    align-items: center;

                    h3 {
                        font-size: 17px;
                        line-height: 22px;
                        color: #303030;
                        font-style: normal;
                        font-weight: 500;
                    }
                    
                    span {
                        font-size: 10px;
                        line-height: 18px;
                        padding: 0 3px;
                        border-radius: 4px;
                        margin-left: 11px;
                    }

                    span.bad {
                        color: #E80505;
                        background-color: rgba(232, 5, 5, 0.054);
                    }

                    span.normal {
                        color: #EF7A0E;
                        background-color: rgba(239, 122, 14, 0.054);
                    }

                    span.good {
                        color: #13C024;
                        background-color: rgba(19, 192, 36, 0.054);
                    }                    
                }

                .left .down {
                    display: flex;
                    align-items: center;

                    span {
                        font-size: 11px;
                        line-height: 22px;
                        color: #4D5B80;
                        margin-left: 2px;
                    }
                }

                .right {
                    text-align: right;

                    .up span{
                        color: #055CE8;
                        font-size: 14px;
                        line-height: 22px;
                    }

                    .down span{
                        color: #4D5B80;
                        font-size: 10px;
                        line-height: 22px;                        
                    }
                }
            }

            .content {
                margin-top: 4px;
                padding: 6px 12px;
                display: flex;
                justify-content: space-between;
                align-items: baseline;
                border-radius: 14px;

                .block {
                    height: 49px;
                    display: flex;
                    flex-direction: column;
                    align-items: start;
                    justify-content: center;

                    .title {
                        font-size: 11px;
                        color: rgba(77, 91, 128, 0.7);
                        font-style: normal;
                        font-weight: 400;
                    }

                    .detail {
                        max-width: 100%;
                    }

                    .detail p {
                        font-size: 15px;
                        line-height: 22px;
                        font-style: normal;
                        font-weight: 400;
                        color: #4d5b80;
                        display: inline-block;
                        max-width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .detail p.todo {
                        color: #E80505;
                    }

                    .detail span {
                        font-size: 12px;
                        line-height: 22px;
                        color: #4d5b80;
                        display: inline-block;
                    }
                }

                .block:nth-child(1) {
                    flex: 0 0 60%;
                    max-width: 60%;
                }

                .block:nth-child(2) {
                    flex: 0 0 40%;
                    max-width: 40%;
                }

                .block:nth-child(3) {
                    flex: 0 0 10%;
                    max-width: 10%;
                }


            }
        }

        .group:first-child {
            border-radius: 24px 24px 0  0;
        }
    }

    .nodata_class {
        position: absolute;
        top: 120px;
        width: 100%;
        height: 100%;
        background-color: #f8f8f8;
        display: flex;
        align-items: center;
        justify-content: center;

        .no_data {
            position: relative;
            top: -100px;

            img {
                width: 252px;
                display: inline-block;
            }

            p {
                padding-top: 22px;
                color: #4d5b80;
                font-size: 16px;
                text-align: center;
            }
        }
    }

    .van-cell::after {
        border: 0
    }
    
    .van-radio--horizontal {
        margin-bottom: 4px;
    }

    .clearSearch {
        text-align: center;
        font-size: 12px;
        color: #3d3d3d;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/index/Customer.vue